var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepperR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 74,
    viewBox: "0 0 14 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46972 2.28357C3.2645 1.56686 2.65845 1.2057 2.11608 1.47688C1.60561 1.73212 1.33348 2.45653 1.47433 3.13839L1.50562 3.26562L10.5557 34.8718C10.9238 36.1572 10.9468 37.5677 10.6248 38.8687L10.5557 39.1274L1.50562 70.7336C1.3004 71.4503 1.57371 72.2511 2.11608 72.5223C2.62655 72.7775 3.19342 72.4726 3.42944 71.8383L3.46972 71.7156L12.5198 40.1094C13.065 38.2057 13.0922 36.1143 12.6016 34.1919L12.5198 33.8898L3.46972 2.28357Z",
    fill: "#077AD3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperR);
export default __webpack_public_path__ + "static/media/Stepper R.c47b1417b1dd32bbc3f3772ab32c2978.svg";
export { ForwardRef as ReactComponent };